import "./auth.scss";
import { Form } from "react-bootstrap";
import InputForm from "../command/input/inputField";
import { Link, useNavigate } from "react-router-dom";
import Button from "../command/Button/Button";
import AuthMainTitle from "../command/authMainTitle/authMainTitle";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { userClient } from "../../data/user";
import { Effect } from "../../assets/svgIcon/customIcon";
import { toast } from "react-toastify";
import OtpFormModal from "./otpFormModal";
import { useState } from "react";

const schema = yup.object().shape({
  email: yup
    .string()
    .email("Email format is invalid")
    .required("Email is required"),
});

const ForgotPasswordForm = () => {
  const { t } = useTranslation();
  const [otpModalShow, setOtpModalShow] = useState(false);
  const [value, setValue] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
    getValues,
  } = useForm({
    //@ts-ignore
    resolver: yupResolver(schema),
    mode: "all",
  });
  const onSubmit = (values: any) => {
    const request = {
      username: values.email,
      userTypeId: 1,
    };
    userClient
      .forgetPassword(request)
      .then((res) => {
        if (res?.success) {
          setOtpModalShow(true);
          toast.success(`${t("sent-verification-code")} ${request.username}`);
        } else {
          toast.error("Something went wrong");
        }
      })
      .catch((error) => {
        toast.error("Something went wrong");
      });
  };

  return (
    <>
      <div className="login-form-section signup-form-section">
        <div className="auth-page-effect effect-add-section">
          <Effect className="effect-img" />
          <AuthMainTitle
            mainTitleText={t("forgot-password-title")}
            className="login-title"
          />
          <Form>
            <InputForm
              inputId="login-email"
              inputLable={t("input-label-email")}
              inputType="email"
              inputPlaceholder={t("auth-email-placeholder")}
              register={register("email")}
              error={errors?.email?.message}
              required
            />
          </Form>
          <div className="form-btn-section">
            <Button
              btnText={t("forgot-password-title")}
              disabled={!isValid}
              onClick={handleSubmit(onSubmit)}
            />
          </div>
          <div className="forgot-link-box signin-link">
            {t("back-to")}{" "}
            <Link to={"/login"} className="auth-link forgot-link">
              {t("sign-in")}
            </Link>
          </div>
        </div>
      </div>

      {/* OTP Modal  clearotp={true}*/}
      <OtpFormModal
        show={otpModalShow}
        username={`${getValues("email")}`}
        onHide={() => setOtpModalShow(false)}
      />
      {/* OTP Modal  */}
    </>
  );
};

export default ForgotPasswordForm;
